import { Outlet } from "react-router-dom";
import Helmet from "react-helmet";

import ProofOfCoverageLayout from "@layouts/ProofOfCoverageLayout";

import { BASE_RESIDENTS_PATH } from "@routing/Residents";
import { PROOF_OF_COVERAGE_ROUTES } from "@routing/Residents/ProofOfCoverage/index";

import { getPageTitle } from "@utils";

export default function AddProofOfCoveragePage() {
  return (
    <>
      <Helmet>
        <title>{getPageTitle("Add proof of coverage")}</title>
      </Helmet>
      <ProofOfCoverageLayout
        onClosePath={`/${BASE_RESIDENTS_PATH}`}
        cannotGoBackPaths={[
          PROOF_OF_COVERAGE_ROUTES.POLICY_TYPE,
          PROOF_OF_COVERAGE_ROUTES.ACTIVE_TLL_FOUND,
          PROOF_OF_COVERAGE_ROUTES.SCHEDULED_TLL_FOUND,
          PROOF_OF_COVERAGE_ROUTES.COVERAGE_ADDED,
        ]}>
        <Outlet />
      </ProofOfCoverageLayout>
    </>
  );
}
